import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { browserIdle } from '@bcf-vanilla-ui-ts-v1/shared/ui-rx/browser-idle';
import { fromEvent, map, merge, Observable, of, shareReplay, zip } from 'rxjs';
import { AppLoaded, provideAppLoaded } from './app-loaded';

export class AppInteraction {
  private _doOnInteractShareRef$!: Observable<void>;

  constructor(
    private _window: Window | undefined,
    private _appLoaded: AppLoaded,
    private _isServer: boolean
  ) {}

  public doOnInteract(): Observable<void> {
    // !isPlatformBrowser(this._platformId)
    if (this._isServer || !this._window) {
      return of(undefined);
    }
    return (this._doOnInteractShareRef$ ??= zip(
      merge(fromEvent(this._window, 'click'), fromEvent(this._window, 'touchstart'), fromEvent(this._window, 'scroll')),
      this._appLoaded.doOnReady(),
      browserIdle(this._window)
    ).pipe(
      map(() => undefined),
      shareReplay(1)
    ));
  }
}

export function provideAppInteraction(_window: Window | undefined, _isServer: boolean): AppInteraction {
  return provideSingleton(AppInteraction, () => new AppInteraction(_window, provideAppLoaded(_window), _isServer));
}
